
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"10","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.339 4.456c-.827-1.279-1.9-2.365-3.102-3.141C10.907.455 9.437 0 7.989 0 6.661 0 5.354.38 4.106 1.128 2.833 1.892 1.68 3.008.678 4.443a.997.997 0 00-.02 1.11C1.484 6.846 2.546 7.934 3.73 8.7 5.063 9.563 6.497 10 7.99 10c1.46 0 2.93-.45 4.256-1.304 1.201-.774 2.272-1.864 3.096-3.153a1.007 1.007 0 00-.003-1.087zM8 8a3 3 0 110-6 3 3 0 010 6z","fill":"#fff"}})])
          )
        }
      }
    